import { computed, inject, provide, ref } from 'vue'

/** Ключ inject для счётчика активных upload в ReplaceableDocumentUpload. */
export const DOCUMENT_UPLOAD_PENDING_KEY = 'form:document-upload-pending'

/**
 * Провайдит ref-счётчик активных загрузок документов для дочерних ReplaceableDocumentUpload.
 *
 * @returns {{ pending: object, isDocumentUploading: object }}
 */
export function provideDocumentUploadPending() {
  const pending = ref(0)
  const isDocumentUploading = computed(() => pending.value > 0)

  provide(DOCUMENT_UPLOAD_PENDING_KEY, pending)

  return { pending, isDocumentUploading }
}

/**
 * Возвращает ref-счётчик активных загрузок документов, если родитель его провайдил.
 *
 * @returns {object|null}
 */
export function useDocumentUploadPending() {
  return inject(DOCUMENT_UPLOAD_PENDING_KEY, null)
}

/**
 * Увеличивает счётчик на время async-операции и уменьшает в finally.
 *
 * @param {object|null} pending Ref-счётчик из provideDocumentUploadPending.
 * @param {Function} fn Async-функция upload.
 * @returns {Promise<*>}
 */
export async function trackDocumentUpload(pending, fn) {
  if (!pending) {
    return fn()
  }

  pending.value += 1

  try {

    return await fn()
  } finally {
    pending.value = Math.max(0, pending.value - 1)
  }
}
